export function formatDateView(date) {
    if (!date) {
        return "";
    }
    if (date instanceof Date) {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    }
    const parsed = new Date(date);
    if (!isNaN(parsed.getTime())) {
        const day = String(parsed.getDate()).padStart(2, '0');
        const month = String(parsed.getMonth() + 1).padStart(2, '0');
        const year = parsed.getFullYear();
        return `${day}/${month}/${year}`;
    }
    return "";
}

export function formatYearView(date) {
    if (!date) {
        return "";
    }
    if (date instanceof Date) {
        return String(date.getFullYear());
    }
    const parsed = new Date(date);
    if (!isNaN(parsed.getTime())) {
        return String(parsed.getFullYear());
    }
    return "";
}

export function formatTimeView(time) {
    if (!time) {
        return "";
    }
    if (time instanceof Date) {
        const hours = String(time.getHours()).padStart(2, '0');
        const minutes = String(time.getMinutes()).padStart(2, '0');
        return `${hours}:${minutes}`;
    }
    const str = String(time);
    return str.substring(0, 5);
}

// Função para calcular dias úteis anteriores
export function calcularDiasUteisAnteriores(data, dias) {
    const newDate = new Date(data);
    let diasRestantes = dias;

    while (diasRestantes > 0) {
        newDate.setDate(newDate.getDate() - 1);

        // Verifica se não é sábado (6) ou domingo (0)
        if (newDate.getDay() !== 0 && newDate.getDay() !== 6) {
            diasRestantes--;
        }
    }
}
